import {
  UPDATE_SIGNIN, UPDATE_USER_PROFILE, UPDATE_USERS
} from "../constants";

const initialUserState = {
  profile: {},
  profile_updated: null,
  users_list: [],
};

export default function user(state = initialUserState, action) {
  switch (action.type) {
    case UPDATE_SIGNIN:
      if (action.clear) {
        localStorage.removeItem('dc_currentChat');
      }
      return {
        ...initialUserState,
        profile: action.profile,
        profile_updated: null
      };
    case UPDATE_USER_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.profile
        },
        profile_updated: Math.random().toString(36)
      };
    case UPDATE_USERS:
      return {
          ...state,
          users_list: action.list
      };
    default:
      return state;
  }
}
